package com.kinoshazam.uiKit.components.videoItem

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.foundation.lazy.grid.LazyGridScope
import androidx.compose.foundation.lazy.grid.items as gridItems
import androidx.compose.foundation.lazy.items
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.extension.shimmer.shimmer
import com.kinoshazam.uiKit.theme.UiKitTheme
import com.kinoshazam.uiKit.theme.largeRadius
import com.kinoshazam.uiKit.theme.middleRadius
import com.kinoshazam.uiKit.theme.smallRadius

private const val SkeletonCount = 6

@Composable
fun CompactBannerSkeleton(modifier: Modifier = Modifier) {
    Box(
        modifier
            .size(width = 130.dp, height = 231.dp)
            .clip(smallRadius)
            .background(UiKitTheme.colors.color_4)
            .shimmer(),
    )
}

@Composable
fun MediumBannerSkeleton(
    modifier: Modifier = Modifier,
    width: Dp = MediumVideoCardWidth,
) {
    val corner = if (width < MediumVideoCardWidth) middleRadius else largeRadius
    Column(modifier.width(width)) {
        Box(
            Modifier
                .fillMaxWidth()
                .aspectRatio(MediumVideoPosterAspectRatio)
                .clip(corner)
                .background(UiKitTheme.colors.color_4)
                .shimmer(),
        )
        Box(
            Modifier
                .padding(top = 8.dp, start = 4.dp)
                .fillMaxWidth(0.72f)
                .height(16.dp)
                .clip(smallRadius)
                .background(UiKitTheme.colors.color_4)
                .shimmer(),
        )
    }
}

fun LazyListScope.compactBannerSkeletons(count: Int = SkeletonCount) {
    items(count) {
        CompactBannerSkeleton()
    }
}

fun LazyListScope.mediumBannerSkeletons(
    count: Int = SkeletonCount,
    width: Dp = MediumVideoCardWidth,
) {
    items(count) {
        MediumBannerSkeleton(width = width)
    }
}

fun LazyGridScope.compactBannerSkeletons(count: Int = 12) {
    gridItems(List(count) { it }) {
        CompactBannerSkeleton()
    }
}

fun LazyGridScope.mediumBannerSkeletons(
    count: Int = 12,
    width: Dp = MediumVideoCardWidth,
) {
    gridItems(List(count) { it }) {
        MediumBannerSkeleton(width = width)
    }
}
